var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 343.8 343.8",
    enableBackground: "new   0 0 343.8 343.8;",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152,253.9H22V59.7l35.8,52.1c2.1,3,5.4,4.8,9.1,4.8h161.5c3.6,0,7-1.8,9.1-4.8l35.8-52.1v96.1 c0,6.1,4.9,11,11,11s11-4.9,11-11V37.2c0-6.1-4.9-11-11-11h-8.7c-0.1,0-0.2,0-0.3,0H20c-0.1,0-0.2,0-0.3,0H11c-6.1,0-11,4.9-11,11 v227.7c0,6.1,4.9,11,11,11h141c6.1,0,11-4.9,11-11S158.1,253.9,152,253.9z M254.5,48.2l-31.8,46.3h-150L40.8,48.2H254.5z  M339.1,234.1l-90.5-63.5c-3.4-2.4-7.8-2.7-11.4-0.8c-3.6,1.9-5.9,5.7-5.9,9.8v30.7H191c-6.1,0-11,4.9-11,11v43.7 c0,2.9,1.2,5.7,3.2,7.8s4.9,3.2,7.8,3.2l40.3,0v30.7c0,4.1,2.3,7.9,5.9,9.8c1.6,0.8,3.3,1.2,5.1,1.2c2.2,0,4.4-0.7,6.3-2l90.5-63.5 c2.9-2.1,4.7-5.4,4.7-9S342.1,236.1,339.1,234.1z M253.4,285.4v-20.5c0-2.9-1.2-5.7-3.2-7.8c-2.1-2.1-4.9-3.2-7.8-3.2l-40.3,0v-21.7 h40.3c6.1,0,11-4.9,11-11v-20.5l60.3,42.4L253.4,285.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.294335e1c0f6ca35b727d72d00b08465.svg";
export { ForwardRef as ReactComponent };